import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Certifications from './components/Certifications';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function App() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <div className="section-alt"><About /></div>
        <Skills />
        <div className="section-alt"><Experience /></div>
        <Projects />
        <div className="section-alt"><Certifications /></div>
        <Contact />
      </main>
      <Footer />
    </>
  );
}
